import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { CLEAR_REGISTRATION_MESSAGE, CLEAR_ERROR, CLEAR_ALL_MESSAGES } from '../actions/planActions';

interface PlanState {
  plans: any[];
  loading: boolean;
  error: string | null;
  registrationMessage: string | null;
  searchResults: any[];
  registeredPlans: any[];
}

const initialState: PlanState = {
  plans: [],
  loading: false,
  error: null,
  registrationMessage: null,
  searchResults: [],
  registeredPlans: [],
};

const planSlice = createSlice({
  name: 'plan',
  initialState,
  reducers: {
    clearRegistrationMessage: (state) => {
      state.registrationMessage = null;
    },
    clearError: (state) => {
      state.error = null;
    },
    clearAllMessages: (state) => {
      state.error = null;
      state.registrationMessage = null;
    },
    registerPlanSuccess: (state, action: PayloadAction<any>) => {
      state.registrationMessage = "Plan registered successfully";
      state.error = null;
      state.registeredPlans.push(action.payload);
    },
    registerPlanFailure: (state, action: PayloadAction<string>) => {
      state.error = action.payload;
      state.registrationMessage = null;
    },
    setSearchResults: (state, action: PayloadAction<any[]>) => {
      //console.log('setSearchResults reducer called with payload:', action.payload);
      state.searchResults = action.payload;
    },
    addRegisteredPlan: (state, action: PayloadAction<any>) => {
      state.registeredPlans.push(action.payload);
    },
    clearSearchResults: (state) => {
      //console.log('Clearing search results in Redux store');
      state.searchResults = [];
    },
    forceResetSearchResults: (state) => {
      //console.log('Forcefully resetting search results in Redux store');
      state.searchResults = [];
      state.loading = false;
      state.error = null;
    },
    setError: (state, action: PayloadAction<string>) => {
      state.error = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(CLEAR_REGISTRATION_MESSAGE, (state) => {
        state.registrationMessage = null;
      })
      .addCase(CLEAR_ERROR, (state) => {
        state.error = null;
      })
      .addCase(CLEAR_ALL_MESSAGES, (state) => {
        state.error = null;
        state.registrationMessage = null;
        state.searchResults = []; // Also clear search results here
      });
  },
});

export const { 
  clearRegistrationMessage, 
  clearError, 
  clearAllMessages, 
  registerPlanSuccess, 
  registerPlanFailure,
  setSearchResults,
  addRegisteredPlan,
  clearSearchResults,
  forceResetSearchResults,
  setError  // Add this line
} = planSlice.actions;

export default planSlice.reducer;
